import { render, staticRenderFns } from "./symptom.vue?vue&type=template&id=00cb9388&scoped=true&"
import script from "./symptom.vue?vue&type=script&lang=js&"
export * from "./symptom.vue?vue&type=script&lang=js&"
import style0 from "./symptom.vue?vue&type=style&index=0&id=00cb9388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb9388",
  null
  
)

export default component.exports